import { render, staticRenderFns } from "./leftPage.vue?vue&type=template&id=906930f6&scoped=true"
import script from "./leftPage.vue?vue&type=script&lang=js"
export * from "./leftPage.vue?vue&type=script&lang=js"
import style0 from "./leftPage.vue?vue&type=style&index=0&id=906930f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906930f6",
  null
  
)

export default component.exports